import React, {Component} from 'react';
import {connect} from 'react-redux';
import {browserHistory} from "react-router";
import {WebinarList} from './elements';
import {Pagination} from '../../../../../common/elements';
import {PaginationHelpers} from '../../../../../../helpers/';
import * as webinarsActions from '../../../../../../actions/training/webinars/webinars';

import Prismic from 'prismic-javascript'
import {PrismicConfig} from '../../../../../../helpers/prismicHelpers/PrismicAPI'
import {LanguagePrismicHelper, PrismicDocumentHelper} from '../../../../../../helpers/prismicHelpers/PrismicHelpers'
import {
    prismicSliceHelper,
    prismicSliceContentRelationship
} from '../../../../../../helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers'
import {sliceComponentsHelper} from '../../../../../../helpers/prismicHelpers/prismic-slice-helpers/SliceComponentsHelpers'
import Loader from '../../../../../common/elements/Loader';
import {siteOfOriginHelper} from '../../../../../../helpers/genericHelpers';
import {WebinarsListHelper} from '../../../../../../helpers/prismicHelpers/prismic-custom-helpers/HomepageCardHelpers';

class WebinarsPage extends Component {

    state = {
        slices: null,
        webinars: ''
    }

    componentWillMount() {
        // const siteOfOrigin = siteOfOriginHelper();
        // if (siteOfOrigin === 'us') {
        //     browserHistory.push('/');
        // }
        this.getWebinarsList();
    };

    async getWebinarsList() {
        const data = await PrismicDocumentHelper('document.type', 'single-webinar', false, 'at');
        const webinars = WebinarsListHelper(data);
        this.setState({webinars});
    }

    async componentDidMount() {
        //prismic
        const prismicConnection = await Prismic.api(PrismicConfig.apiEndpoint, {accessToken: PrismicConfig.apiAccessTokes});
        const json = await prismicConnection.query(Prismic.Predicates.at('my.flexible-layout.uid', 'interactive-webinars'), LanguagePrismicHelper());
        let {slices} = prismicSliceHelper(json);
        slices = (slices && slices.length) ? await prismicSliceContentRelationship(slices, prismicConnection) : null;
        this.setState({slices})
    };

    render() {
        const {slices, webinars} = this.state;
        if (!webinars || !slices) {
            return <Loader/>;
        }
        return (
            <div className="webinars-body">
                {sliceComponentsHelper(slices)}
                <main className="container interactive-webinars-page theme-page-content-wrapper">
                    <div className="row">
                        <div className="col-12 heading-section no-margin">
                            <p className="body-copy">{slices[0].subtitle}</p>
                        </div>
                    </div>
                    <WebinarList webinars={webinars}/>
                </main>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        webinars: state.webinars.webinars,
        paging: state.webinars.pagination,
    };
}

export default connect(mapStateToProps)(WebinarsPage);





// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/WebinarsPage.js